module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"content_hubs":{"index":{"meta_tags":{"description":"All information about %{tag_list} on CAPinside: news, funds, analysis, portfolios, advisor search and networking events on one platform.","title":"Fund information on %{tag_list}"}},"related_fonds":"Related Fonds","related_articles":"Related Articles","related_content_hubs":"Related Content Hubs"}}}}}')
  delete Component.options._Ctor
}
